export default __webpack_public_path__ + "static/media/location-icon.958f0cf5.svg";